const MESSAGE = {
    alert: 'Are you sure you want to ',
    alertDecomission: 'You have decommissioned ',
    addSuccess: 'Successfully added ',
    error: 'Something went wrong.',
    updateSuccess: 'Successfully updated ',
    assignedSuccess: ' has been assigned to ',
    unassignedSuccess: ' has been unassigned',
    decommission: 'decommission ',
    assign: 'assign',
    unassign: 'unassign ',
    success: 'Success!',
    delete: 'delete'
};

export default MESSAGE;



// WEBPACK FOOTER //
// ./src/app/helpers/message.js